// 提取obj里面的
// lodash.pick的代替品
export function pick(obj, keys) {
  // eslint-disable-line
  return keys.reduce(function(result, key) {
    if (obj[key]) {
      result[key] = obj[key]
    }
    return result
  }, {})
}

// lodash.omit的代替品
export function omit(obj, keys) {
  var result = {},
    key

  for (key in obj) {
    if (keys.indexOf(key) == -1) result[key] = obj[key]
  }

  return result
}

export function uniq(list, key) {
  var _map = {}
  var list_temp = [...list]

  for (let i = 0; i < list_temp.length; i++) {
    const match = list_temp[i][key]

    if (_map[match]) {
      list_temp.splice(i, 1, '')
    }

    _map[match] = true
  }

  return list_temp.filter(v => !!v)
}

export const sortByRule = (list, key, rule) => {
  if (!Array.isArray(list) || !Array.isArray(rule)) return
  const result = []
  rule.map(ret => {
    result.push(...list.filter(v => v[key] === ret))
  })
  result.push(...list.filter(v => !v[key] || rule.indexOf(v[key]) === -1))
  return result
}



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/objOperation.js